<template>
    <Head title="FAQs" />
    <div class="px-4 md:px-8">
        <Faqs />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import Faqs from '@/components/faq.vue';
</script>
